"use client";

import { Badge } from "./ui/badge";

const TestBadge = () => {
  if (process.env.NEXT_PUBLIC_APP_ENV == "test")
    return (
      <div className="fixed bottom-1 left-1 w-fit select-none z-50">
        <Badge variant="destructive">TEST MODE</Badge>
      </div>
    );
};

export default TestBadge;
